<template>
  <div class="about">
    <h1>新元号.jpについて</h1>
    <p>当Webサイトは、株式会社イワテシガが運営しています。</p>
    <div v-if="$profile.user && $profile.user.uid == 'LdwcRZ1HRsdynT0NTKqOqAPQnaF3'" >
      <h3>開発者モード</h3>
      <p>指定されたユーザーのみこの領域を描画します。</p>
      <b-button v-on:click="hello()">Call hello</b-button>
      <b-button v-on:click="archive()">Call achive</b-button>
      <b-button v-on:click="checkAndOneArchive()">Call checkAndOneArchive</b-button>
      <b-button v-on:click="analyzeMorphology()">Call analyzeMorphology</b-button>
      <b-button v-on:click="word2vec()">Call word2vec</b-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    hello() {
      const hello = this.$functions.httpsCallable('hello');
      hello().then(result => {
        this.log('https Callable hello result = ', result);
        alert(result.data);
      });
    },
    archive() {
      const archive = this.$functions.httpsCallable('archiveFile');
      archive({url:'http://news.livedoor.com/topics/detail/16516458', path: '/test/0526'}).then(result => {
        this.log('https Callable hello result = ', result);
      });
    },
    checkAndOneArchive() {
      const checkAndOneArchive = this.$functions.httpsCallable('checkAndOneArchive');
      checkAndOneArchive().then(result => {
        this.log('checkAndOneArchive result = ', result);
      });
    },
    analyzeMorphology() {
      const analyzeMorphology = this.$functions.httpsCallable('analyzeMorphology');
      analyzeMorphology({text:'28日まで発売中の「新元号記念くじ」を女性セブンが紹介している。発行枚数は「ドリームジャンボ宝くじ」の6分の1以下で、追加発行もない。そのため、売り場によっては発売 ...'}).then(result => {
        this.log('analyzeMorphology result = ', result);
      });
    },
    word2vec() {
      const word2vec = this.$functions.httpsCallable('word2vec');
      word2vec({}).then(result => {
          this.log('word2vec result = ', result);
      });
    }
  }
}
</script>

<style>

</style>
